import React, { useState } from 'react';
import './RadioButtunTable.css';

function A1RadioButtonMapped(props) {
  const [activeSubId, setActiveSubId] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [sortConfig, setSortConfig] = useState({ column: null, direction: 'asc' });

  if (!props?.item?.text) return null;

  let data = {};
  try {
    data = JSON.parse(props.item.text);
  } catch (e) {
    return null;
  }

  const subIds = Object.keys(data);
  if (subIds.length === 0) return null;

  // Set first subId as active by default
  const currentSubId = activeSubId || subIds[0];
  const currentData = data[currentSubId]?.tsAgentAssistTable;
  const infoText = data[currentSubId]?.infoText || '';
  const { tableHeading, tableRows, isRadioButton } = currentData || {};

  const handleSubIdClick = (subId) => {
    setActiveSubId(subId);
    setSelectedRowIndex(null);
    setSortConfig({ column: null, direction: 'asc' });
  };

  const handleSort = (colIndex) => {
    const direction = sortConfig.column === colIndex && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ column: colIndex, direction });
  };

  const getSortedRows = (rows) => {
    if (!rows || sortConfig.column === null) return rows || [];
    return [...rows].sort((a, b) => {
      const aVal = a[sortConfig.column];
      const bVal = b[sortConfig.column];
      const aText = aVal?.replace(/<[^>]*>/g, '') || '';
      const bText = bVal?.replace(/<[^>]*>/g, '') || '';
      const aNum = parseFloat(aText);
      const bNum = parseFloat(bText);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
      }
      return sortConfig.direction === 'asc' ? aText.localeCompare(bText) : bText.localeCompare(aText);
    });
  };

  const sortedRows = getSortedRows(tableRows);

  const handleRowSelect = (rowIndex) => {
    setSelectedRowIndex(rowIndex);
    props?.setErrors?.((prevErrors) => {
      const RowIdArray = tableRows[rowIndex];
      return {
        ...prevErrors,
        [props?.index]: {
          key1: `${activeSubId || subIds[0]},${RowIdArray[0]}`,
          displayName: `${activeSubId || subIds[0]},${RowIdArray[0]}`,
        },
      };
    });
  };

  const renderCell = (cellData, colIndex) => {
    if (cellData && typeof cellData === 'object') return <td key={colIndex}>-</td>;
    return (
      <td key={colIndex} dangerouslySetInnerHTML={{ __html: cellData || "-" }} />
    );
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '0px 12px' }}>
      <div className="subid-tabs">
        {subIds.map((subId) => (
          <div key={subId} className="subid-tab-wrapper">
            <button
              className={`subid-tab ${currentSubId === subId ? 'subid-tab--active' : ''}`}
              onClick={() => handleSubIdClick(subId)}
            >
              {subId}
            </button>
            {data[subId]?.infoText && (
              <span className="subid-tooltip">{data[subId].infoText}</span>
            )}
          </div>
        ))}
      </div>

      {currentData && tableRows?.length > 0 && (
        <div className="responsive-table-container">
          <table className="custom-table">
            <thead>
              <tr>
                {isRadioButton && <th className="radio-column A3f"></th>}
                {tableHeading?.map((heading, index) => (
                  <th
                    key={index}
                    onClick={() => handleSort(index)}
                    className={sortConfig.column === index ? 'sorted-column' : ''}
                    style={{ cursor: 'pointer' }}
                  >
                    {heading}
                    <span style={{ marginLeft: '5px' }}>
                      {sortConfig.column === index
                        ? (sortConfig.direction === 'asc' ? '↑' : '↓')
                        : '↕'}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedRows.map((row, rowIndex) => {
                const isSelected = selectedRowIndex === rowIndex;
                return (
                  <tr
                    key={rowIndex}
                    className={`table-row ${isSelected ? "selected-row" : ""}`}
                    onClick={() => handleRowSelect(rowIndex)}
                  >
                    {isRadioButton && (
                      <td className="radio-column">
                        <input
                          type="radio"
                          name="row-select"
                          checked={isSelected}
                          onChange={() => handleRowSelect(rowIndex)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </td>
                    )}
                    {tableHeading?.map((_, colIndex) => renderCell(row[colIndex], colIndex))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default A1RadioButtonMapped;
